import { api } from "../api";
import type { SearchResponse } from "./search.types";

export const searchApi = {
    async search(query: string, limit = 10): Promise<SearchResponse> {
        const params = new URLSearchParams();
        params.set("q", query);
        params.set("limit", String(limit));
        const response = await api.get<SearchResponse>(`/search?${params}`);
        return response.data;
    },
};
